import { network } from 'services/network';

import { QueryFnResponse, QueryParams } from 'api/queries/getCrossVersionsTrends.query';

export const ENDPOINT = 'api/bo/getCrossVersionsTrends';

export const getCrossVersionsTrends = (params: QueryParams) => {
    return network.post<QueryFnResponse>(ENDPOINT, params).then((response) => response.data);
};
